/**
 * DAYS N'DAYS - DND PAGES
 * Scripts compartilhados para páginas bem-vindo e família
 * Vanilla JavaScript - ES6 Class Pattern
 */

class DndPagesController {
  constructor() {
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.init();
  }

  init() {
    this.initRevealAnimations();
    this.initGalleryDragScroll();
    this.initLightbox();
    this.initKeyboardShortcuts();
  }

  /**
   * Reveal animations on scroll (IntersectionObserver)
   */
  initRevealAnimations() {
    if (this.prefersReducedMotion) return;

    // Standard reveal elements
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -28px 0px',
      }
    );

    document.querySelectorAll('.dnd-rv').forEach((el) => {
      revealObserver.observe(el);
    });

    // Stagger reveal for ranking rows
    const staggerRows = document.querySelectorAll('.dnd-rv-stagger');
    if (staggerRows.length > 0) {
      const staggerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const index = [...staggerRows].indexOf(entry.target);
              entry.target.style.transitionDelay = `${index * 0.07}s`;
              entry.target.classList.add('in');
              staggerObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.05,
        }
      );

      staggerRows.forEach((row) => staggerObserver.observe(row));
    }
  }

  /**
   * Gallery drag scroll (mobile)
   */
  initGalleryDragScroll() {
    const galleryScroll = document.querySelector('.dnd-gallery-scroll');
    if (!galleryScroll) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let dragged = false;

    galleryScroll.addEventListener('mousedown', (e) => {
      isDown = true;
      dragged = false;
      galleryScroll.classList.add('dragging');
      startX = e.pageX - galleryScroll.offsetLeft;
      scrollLeft = galleryScroll.scrollLeft;
    });

    galleryScroll.addEventListener('mouseleave', () => {
      isDown = false;
      galleryScroll.classList.remove('dragging');
    });

    galleryScroll.addEventListener('mouseup', () => {
      isDown = false;
      galleryScroll.classList.remove('dragging');
    });

    galleryScroll.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - galleryScroll.offsetLeft;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 4) dragged = true;
      galleryScroll.scrollLeft = scrollLeft - walk;
    });

    // Prevent click-through after drag
    galleryScroll.addEventListener(
      'click',
      (e) => {
        if (dragged) e.stopPropagation();
      },
      true
    );
  }

  /**
   * Lightbox for gallery images
   */
  initLightbox() {
    const lightbox = document.querySelector('.dnd-lightbox-overlay');
    if (!lightbox) return;

    const lightboxImg = lightbox.querySelector('img');
    const lightboxImages = document.querySelectorAll('.dnd-img-lightbox');

    lightboxImages.forEach((img) => {
      img.style.cursor = 'pointer';
      img.addEventListener('click', () => {
        lightboxImg.src = img.src;
        lightboxImg.alt = img.alt || '';
        lightbox.classList.add('open');
      });
    });

    // Close lightbox on click
    lightbox.addEventListener('click', () => {
      lightbox.classList.remove('open');
    });
  }

  /**
   * Keyboard shortcuts
   */
  initKeyboardShortcuts() {
    document.addEventListener('keydown', (e) => {
      // ESC to close lightbox
      if (e.key === 'Escape') {
        const lightbox = document.querySelector('.dnd-lightbox-overlay');
        if (lightbox) {
          lightbox.classList.remove('open');
        }
      }
    });
  }
}

/**
 * Form handlers
 */
class DndFormHandlers {
  /**
   * Show success message
   */
  static showSuccess(messageEl, text) {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.style.display = 'block';
    messageEl.style.color = 'rgba(234, 234, 234, 0.6)';
  }

  /**
   * Show error message
   */
  static showError(messageEl, text) {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.style.display = 'block';
    messageEl.style.color = 'rgba(234, 234, 234, 0.5)';
  }

  /**
   * Show success message (dark mode)
   */
  static showSuccessDark(messageEl, text) {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.style.display = 'block';
    messageEl.style.color = 'rgba(18, 18, 18, 0.7)';
  }

  /**
   * Show error message (dark mode)
   */
  static showErrorDark(messageEl, text) {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.style.display = 'block';
    messageEl.style.color = 'rgba(18, 18, 18, 0.5)';
  }
}

// Auto-initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DndPagesController();
  });
} else {
  new DndPagesController();
}

// Export for use in other scripts if needed
window.DndPagesController = DndPagesController;
window.DndFormHandlers = DndFormHandlers;
